/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  NotFoundErrorResult,
  ResultOfFundsViewModel,
  ResultOfListOfBankBranchViewModel,
  ResultOfListOfLookupTypeCollectionResponseModel,
  ResultOfListOfLookupTypeResponseModel,
  ResultOfListOfSimplifiedLookupResponseViewModel,
  ResultOfSigningLookupsViewModel,
  ResultOfVatViewModel,
  ValidationErrorResult,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultOfFundsViewModelFromJSON,
    ResultOfFundsViewModelToJSON,
    ResultOfListOfBankBranchViewModelFromJSON,
    ResultOfListOfBankBranchViewModelToJSON,
    ResultOfListOfLookupTypeCollectionResponseModelFromJSON,
    ResultOfListOfLookupTypeCollectionResponseModelToJSON,
    ResultOfListOfLookupTypeResponseModelFromJSON,
    ResultOfListOfLookupTypeResponseModelToJSON,
    ResultOfListOfSimplifiedLookupResponseViewModelFromJSON,
    ResultOfListOfSimplifiedLookupResponseViewModelToJSON,
    ResultOfSigningLookupsViewModelFromJSON,
    ResultOfSigningLookupsViewModelToJSON,
    ResultOfVatViewModelFromJSON,
    ResultOfVatViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface LookupsGetAllFundsRequest {
    productId?: number;
}

export interface LookupsGetAllFundsForIntermediariesRequest {
    intermediaryCodes?: Array<number> | null;
    productId?: number;
}

export interface LookupsGetBankBranchCodesAndNamesRequest {
    bankNameId?: string | null;
    searchTerm?: string | null;
}

export interface LookupsGetFromCacheRequest {
    lookupTypeKey?: string | null;
}

export interface LookupsGetOneFromCacheRequest {
    lookupTypeKey?: string | null;
}

export interface LookupsGetSigningLookupsRequest {
    partyType?: LookupsGetSigningLookupsPartyTypeEnum;
}

/**
 * 
 */
export class LookupsApi extends runtime.BaseAPI {

    /**
     * Get all funds available on the platform
     */
    async lookupsGetAllFundsRaw(requestParameters: LookupsGetAllFundsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfFundsViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.productId !== undefined) {
            queryParameters['productId'] = requestParameters.productId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/lookups/all-funds`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfFundsViewModelFromJSON(jsonValue));
    }

    /**
     * Get all funds available on the platform
     */
    async lookupsGetAllFunds(requestParameters: LookupsGetAllFundsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfFundsViewModel> {
        const response = await this.lookupsGetAllFundsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all funds available for the provided intermediaries
     */
    async lookupsGetAllFundsForIntermediariesRaw(requestParameters: LookupsGetAllFundsForIntermediariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfFundsViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.intermediaryCodes) {
            queryParameters['intermediaryCodes'] = requestParameters.intermediaryCodes;
        }

        if (requestParameters.productId !== undefined) {
            queryParameters['productId'] = requestParameters.productId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/lookups/intermediaries-funds`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfFundsViewModelFromJSON(jsonValue));
    }

    /**
     * Get all funds available for the provided intermediaries
     */
    async lookupsGetAllFundsForIntermediaries(requestParameters: LookupsGetAllFundsForIntermediariesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfFundsViewModel> {
        const response = await this.lookupsGetAllFundsForIntermediariesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the bank account types.
     */
    async lookupsGetBankAccountTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfListOfSimplifiedLookupResponseViewModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/lookups/bank-account-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfListOfSimplifiedLookupResponseViewModelFromJSON(jsonValue));
    }

    /**
     * Gets the bank account types.
     */
    async lookupsGetBankAccountTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfListOfSimplifiedLookupResponseViewModel> {
        const response = await this.lookupsGetBankAccountTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets the bank account types.
     */
    async lookupsGetBankBranchCodesAndNamesRaw(requestParameters: LookupsGetBankBranchCodesAndNamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfListOfBankBranchViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.bankNameId !== undefined) {
            queryParameters['bankNameId'] = requestParameters.bankNameId;
        }

        if (requestParameters.searchTerm !== undefined) {
            queryParameters['searchTerm'] = requestParameters.searchTerm;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/lookups/bank-branches`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfListOfBankBranchViewModelFromJSON(jsonValue));
    }

    /**
     * Gets the bank account types.
     */
    async lookupsGetBankBranchCodesAndNames(requestParameters: LookupsGetBankBranchCodesAndNamesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfListOfBankBranchViewModel> {
        const response = await this.lookupsGetBankBranchCodesAndNamesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the bank names.
     */
    async lookupsGetBankNamesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfListOfSimplifiedLookupResponseViewModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/lookups/bank-names`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfListOfSimplifiedLookupResponseViewModelFromJSON(jsonValue));
    }

    /**
     * Gets the bank names.
     */
    async lookupsGetBankNames(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfListOfSimplifiedLookupResponseViewModel> {
        const response = await this.lookupsGetBankNamesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get lookup results based on provided lookup key(s).
     */
    async lookupsGetFromCacheRaw(requestParameters: LookupsGetFromCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfListOfLookupTypeCollectionResponseModel>> {
        const queryParameters: any = {};

        if (requestParameters.lookupTypeKey !== undefined) {
            queryParameters['lookupTypeKey'] = requestParameters.lookupTypeKey;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/lookups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfListOfLookupTypeCollectionResponseModelFromJSON(jsonValue));
    }

    /**
     * Get lookup results based on provided lookup key(s).
     */
    async lookupsGetFromCache(requestParameters: LookupsGetFromCacheRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfListOfLookupTypeCollectionResponseModel> {
        const response = await this.lookupsGetFromCacheRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get lookup results based on provided lookup key.
     */
    async lookupsGetOneFromCacheRaw(requestParameters: LookupsGetOneFromCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfListOfLookupTypeResponseModel>> {
        const queryParameters: any = {};

        if (requestParameters.lookupTypeKey !== undefined) {
            queryParameters['lookupTypeKey'] = requestParameters.lookupTypeKey;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/lookups/GetOneFromCache`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfListOfLookupTypeResponseModelFromJSON(jsonValue));
    }

    /**
     * Get lookup results based on provided lookup key.
     */
    async lookupsGetOneFromCache(requestParameters: LookupsGetOneFromCacheRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfListOfLookupTypeResponseModel> {
        const response = await this.lookupsGetOneFromCacheRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get lookup details for source of funds
     */
    async lookupsGetProviderNamesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfListOfSimplifiedLookupResponseViewModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/lookups/provider-names`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfListOfSimplifiedLookupResponseViewModelFromJSON(jsonValue));
    }

    /**
     * Get lookup details for source of funds
     */
    async lookupsGetProviderNames(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfListOfSimplifiedLookupResponseViewModel> {
        const response = await this.lookupsGetProviderNamesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get lookup details for signing screen
     */
    async lookupsGetSigningLookupsRaw(requestParameters: LookupsGetSigningLookupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfSigningLookupsViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.partyType !== undefined) {
            queryParameters['partyType'] = requestParameters.partyType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/lookups/signings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfSigningLookupsViewModelFromJSON(jsonValue));
    }

    /**
     * Get lookup details for signing screen
     */
    async lookupsGetSigningLookups(requestParameters: LookupsGetSigningLookupsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfSigningLookupsViewModel> {
        const response = await this.lookupsGetSigningLookupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get lookup details for source of funds
     */
    async lookupsGetSourceOfFundsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfListOfSimplifiedLookupResponseViewModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/lookups/source-of-funds`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfListOfSimplifiedLookupResponseViewModelFromJSON(jsonValue));
    }

    /**
     * Get lookup details for source of funds
     */
    async lookupsGetSourceOfFunds(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfListOfSimplifiedLookupResponseViewModel> {
        const response = await this.lookupsGetSourceOfFundsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get the VAT Rate from Ref Data
     */
    async lookupsGetVatRateRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfVatViewModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/lookups/vat-rate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfVatViewModelFromJSON(jsonValue));
    }

    /**
     * Get the VAT Rate from Ref Data
     */
    async lookupsGetVatRate(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfVatViewModel> {
        const response = await this.lookupsGetVatRateRaw(initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const LookupsGetSigningLookupsPartyTypeEnum = {
    I: 'I',
    T: 'T',
    C: 'C',
    N: 'N'
} as const;
export type LookupsGetSigningLookupsPartyTypeEnum = typeof LookupsGetSigningLookupsPartyTypeEnum[keyof typeof LookupsGetSigningLookupsPartyTypeEnum];
